import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-dark-card border-y border-dark-border mt-[-10px] mb-[-10px]" data-id="element-75">
      <div className="max-w-3xl mx-auto text-center" data-id="element-76">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="mt-[10px] mb-[10px]" data-id="element-77">
          <motion.h2 variants={itemVariants} className="text-3xl sm:text-4xl font-serif mb-12 text-zinc-400" data-id="element-78">
            Your dreams feel:
          </motion.h2>

          <div className="space-y-6 mb-16" data-id="element-79">
            {['random', 'confusing', 'meaningless'].map((word, index) => <motion.div key={word} variants={itemVariants} className="text-5xl sm:text-6xl md:text-7xl font-bold text-white italic" data-id="element-80">
                {word}
              </motion.div>)}
          </div>

          <motion.div variants={itemVariants} data-id="element-81">
            <p className="text-2xl sm:text-3xl text-gold-light font-serif" data-id="element-82">
              So you ignore them.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}